/* import __COLOCATED_TEMPLATE__ from './choose-part.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Utils from '../../utils/utils';

export default class ChoosePartModal extends Component {
  @service intl;
  @service('aditools-analytics') analytics;

  selectedPart = null;
  modalId = null;
  gridId = null;
  gridContainerId = null;
  submitButton = null;

  constructor(owner, args) {
    super(owner, args);

    this.submitButton = {
      clickAction: this.onSelect,
      text: this.intl.t('labels.modal.button.select'),
      type: 'primary',
    };

    this.modalId = `${this.args.modalType}-modal`;
    this.gridId = `${this.args.modalType}-grid`;
    this.gridContainerId = `${this.gridId}-container`;
  }

  get type() {
    if (!(this.args.metadata && this.args.metadata.appName)) return '';
    return this.intl.t(`labels.parts.${this.args.metadata.appName}`);
  }

  get article() {
    if (!(this.args.metadata && this.args.metadata.article)) return '';
    return this.intl.t(`labels.articles.${this.args.metadata.article}`);
  }

  @action setSelectedItem(selected) {
    if (selected) {
      let selectedItem = this.args.gridData.data.data.find((item) => item.name === selected);
      this.selectedPart = selectedItem;
    }
  }

  @action onModalShow() {
    if (this.args.handlePartModalShow) this.args.handlePartModalShow();
  }

  @action onModalHide() {
    if (this.args.handlePartModalHide) this.args.handlePartModalHide();
  }

  @action onSelect(closeDialog) {
    if (this.args.setSelectedItem) this.args.setSelectedItem(this.selectedPart);
    if (this.args.handlePartSelection) this.args.handlePartSelection();
    this.args.model.modalHandler.closeModal(this.args.modalType);

    this.analytics.setWebEvent(Utils.getToolName(), 'selectPart', `${this.type}: ${this.selectedPart.name}`);

    if (closeDialog) {
      closeDialog();
    }
  }
}
